if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');

          // Shopify renvoie la section entière — on cherche d'abord
          // le <product-recommendations> dans la réponse
          const recoEl = doc.querySelector('product-recommendations');
          if (recoEl) {
            const inner = recoEl.innerHTML.trim();
            if (inner.length) {
              this.innerHTML = inner;
              return;
            }
          }

          // Fallback : on cherche directement la grille de produits
          const grid = doc.querySelector('.mbr-grid');
          if (grid) {
            this.innerHTML = '';
            this.appendChild(document.importNode(grid, true));
            return;
          }

          // Aucune recommandation disponible pour ce produit
          this.innerHTML = '';
        })
        .catch((error) => {
          console.error('Product recommendations failed to load:', error);
          this.innerHTML = '';
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}